import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { ExperienceIframe, ExperienceIframeContainer, MainContainer } from './Landing.style';
import { apiServiceInstance } from '../utils/services/ApiService';
import { Logger } from '../utils/Logger';

export const Landing: React.FunctionComponent = () => {
  const { search } = useLocation();
  const [searchParams] = useSearchParams();
  const siteKey = searchParams.get('siteKey');

  useEffect(
    () => {
      if (siteKey !== null) {
        apiServiceInstance.fetchSiteData(siteKey).then((data) => {
          if (data.err === undefined && data.site !== undefined && data.site !== null) {
            if (data.site.name !== null) {
              document.title = `${data.site.name} - Votre jeu`;
            }
          } else {
            Logger.error(
              'Something happen while fetching site config in landing',
              data.err
            );
          }
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return <>
    <MainContainer>
      <ExperienceIframeContainer>
        <ExperienceIframe src={`/${search}`} />
      </ExperienceIframeContainer>
    </MainContainer>
  </>;
};
